import React from "react";
import { BrowserRouter } from "react-router-dom";
import Lenis from "lenis";
import HomePage from "./pages/HomePage";
import AdminPage from "./pages/AdminPage";
import LocalityPage from "./pages/LocalityPage";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="min-h-screen grid place-items-center bg-hydro-navy text-white text-center p-8">
          <p>Ceva n-a mers bine. Te rugăm să reîmprospătezi pagina.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  const path = window.location.pathname;
  const isAdmin = path.startsWith("/admin");
  const localityMatch = path.match(/^\/foraje-puturi\/([a-z0-9-]+)\/?$/);

  React.useEffect(() => {
    if (isAdmin) return undefined;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const hash = a.getAttribute("href");
      if (hash.length > 1 && document.querySelector(hash)) {
        e.preventDefault();
        lenis.scrollTo(hash, { offset: -64, duration: 1.4 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, [isAdmin]);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        {isAdmin ? (
          <AdminPage />
        ) : localityMatch ? (
          <LocalityPage slug={localityMatch[1]} />
        ) : (
          <HomePage />
        )}
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
